var map = {
	"./BatteryPower.svg": 11383,
	"./IsBio.svg": 6225,
	"./IsNatural.svg": 61447,
	"./IsSustainable.svg": 98012,
	"./IsTravelPacking.svg": 75186,
	"./IsVegan.svg": 84796,
	"./MainsPower.svg": 86807,
	"./MedicalDevice.svg": 85290,
	"./WithSpf.svg": 48422,
	"./WithoutAlcohol.svg": 5353,
	"./WithoutAluminium.svg": 55895,
	"./WithoutPerfume.svg": 38186,
	"./WithoutSilicone.svg": 64991,
	"./WithoutSulfate.svg": 550
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 41079;